export default __webpack_public_path__ + "static/media/2.07a0cdb8.png";